import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { App, NavController, NavParams, ToastController, ViewController } from 'ionic-angular';

import { AuthProvider } from '../../../../../providers/auth/auth';
import { EmployeeRhProvider } from '../../../../../providers/employeerh/employeerh';


@Component({
    selector: 'page-rh-interview-display',
    templateUrl: 'rh-interview-display.html',
})
export class RhInterviewDisplayPage implements OnInit {

    interview: any = null;
    goals: any = null;
    id: any = null
    isCustom: boolean = false;
    // Signatures 
    user_signature: any = null;
    manager_signature: any = null;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public storageProvider: Storage,
        public app: App,
        public authProvider: AuthProvider,
        public employeeRhProvider: EmployeeRhProvider,
        public viewCtrl: ViewController,
        public toastCtrl: ToastController
    ) {
        this.id = this.navParams.get('id');
        this.isCustom = this.navParams.get('isCustom');
    }

    ngOnInit() {
        this.loadDatas();
    }

    loadDatas() {
        if (!this.isCustom) {
            this.employeeRhProvider.getFullInterview(this.id).subscribe((res) => {
                if (res.success) {
                    this.interview = res.data.output;
                    this.goals = res.data.goals
                }
            })
        } else {
            this.employeeRhProvider.getFullCustomInterview(this.id).subscribe((res) => {
                if (res.success) {
                    this.interview = res.data;
                    this.goals = null;
                    this.user_signature = this.ab2str(res.data.interview.user_signature)
                    this.manager_signature = this.ab2str(res.data.interview.manager_signature)
                    this.interview.interview.Interview.Sets = res?.data?.interview?.Interview?.Sets.sort(this.compare)
                    for (let set of this.interview.interview.Interview.Sets) {
                        set.QuestionSets.Questions = set.QuestionSets.Questions.sort(this.compare)
                    }
                    this.goals = res.data.goals

                }
            })
        }
    }

    // Utils
    compare(a, b) {
        if (a.orderNumber < b.orderNumber) {
            return -1;
        }
        if (a.orderNumber > b.orderNumber) {
            return 1;
        }
        return 0;
    }



    // Answer formating
    getRangeAnswer(value) {
        switch (value) {
            case 5:
                return 'Excellent'


            case 4:
                return 'Bon'


            case 3:
                return 'Moyen'


            case 2:
                return 'Passable'


            case 1:
                return 'Mauvais'


            default:
                break;
        }
    }

    getPerfValue(value) {
        switch (value) {
            case 1:
                return 'En difficulté'


            case 2:
                return 'En développement'


            case 3:
                return 'Performant'


            case 4:
                return 'Super performant'


            case 5:
                return 'Trop tôt pour répondre'


            default:
                break;
        }
    }

    getEvolutionValue(value) {
        switch (value) {
            case 1:
                return 'Je suis satisfait dans mon travail actuel et ne souhaite pas prendre de nouvelles fonctions dans un avenir proche.'


            case 2:
                return 'Je souhaiterais accéder à des responsabilités supplémentaires et / ou envisager de prendre de nouvelles fonctions.'


            case 3:
                return 'Je souhaiterais progresser dans mon poste actuel pour envisager une évolution professionnelle à moyen terme.'


            default:
                break;
        }
    }

    getInterrestedEvolutionValue(value) {
        switch (value) {
            case 1:
                return 'Oui'


            case 2:
                return 'Non'


            case 3:
                return 'Je ne sais pas'


            default:
                break;
        }
    }

    getGoalValue(value) {
        switch (value) {
            case 0:
                return 'Non'

            case 1:
                return 'En partie'

            case 2:
                return 'Oui'

            default:
                break;
        }
    }

    ab2str(arraybuffer) {
        return new TextDecoder("utf-8").decode(new Uint8Array(arraybuffer));
    }


    // Modal ctrl
    dismiss() {
        this.viewCtrl.dismiss();
    }


}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-interview/rh-interview-display/rh-interview-display.ts